export default {
      id: "phone-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }